"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToBasket = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _types = require("../types");
const addToBasket = ({
  event,
  globalApiClient,
  language,
  customerId,
  query
}) => {
  const {
    itemCode
  } = event.detail;
  const date = new Date();
  if (itemCode) {
    const signalData = {
      type: 'cart',
      timeStamp: date,
      params: {
        count: 1,
        docId: itemCode,
        filterQueries: ['products'],
        position: 1,
        query,
        searchTime: Math.floor(date.getTime() / 1000),
        source: 'add-to-basket',
        totalHits: 1,
        userId: customerId.toString()
      }
    };
    void (0, _globalApiClientReact.createApplicationsNavigationSignal)(globalApiClient, signalData, {
      [_types.ACCEPT_LANGUAGE]: language
    });
  }
};
exports.addToBasket = addToBasket;
